import React from "react";

import { containersStyles } from "./Styles";

const ContentContainer = ({children}) => {
    const styles = containersStyles();
    return(
        <div className={styles.contentContainer}>
            {children}
        </div>
    )
}

export default ContentContainer